module.exports = __webpack_public_path__ + "img/east-carolina-seal.1e3095a0.png";